import { useEffect, useState, type ReactNode } from "react";
import { ClientLocationContext } from "./client-location-context";

type ClientLocationProviderProps = {
  children: ReactNode;
};

const DEFAULT_LOCATION = "INTL";
const GEOLOCATION_TIMEOUT_MS = 3000;

export const ClientLocationProvider = ({
  children,
}: ClientLocationProviderProps) => {
  const [location, setLocation] = useState<string>(DEFAULT_LOCATION);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isCancelled = false;
    const timeoutId = window.setTimeout(() => {
      if (!isCancelled) {
        setIsLoading(false);
      }
    }, GEOLOCATION_TIMEOUT_MS);

    (async () => {
      try {
        const data = await requestLocation();
        if (isCancelled) {
          return;
        }
        clearTimeout(timeoutId);
        setLocation(data.country_code ?? DEFAULT_LOCATION);
      } catch (error) {
        if (!isCancelled) {
          console.error("Error fetching location:", error);
          setLocation("EU");
        }
      } finally {
        if (!isCancelled) {
          setIsLoading(false);
        }
      }
    })();

    return () => {
      isCancelled = true;
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <ClientLocationContext.Provider value={{ location, isLoading }}>
      {children}
    </ClientLocationContext.Provider>
  );
};

const requestLocation = async () => {
  const response = await fetch("https://ipapi.co/json");
  const data = await response.json();
  return data;
};
